"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.extractRoutes = exports.isRouteDisabled = void 0;
const moize_1 = __importDefault(require("moize"));
const isRouteDisabled = (disabled = false) => (typeof disabled === 'function' ? disabled() : disabled);
exports.isRouteDisabled = isRouteDisabled;
exports.extractRoutes = (0, moize_1.default)((sections) => sections.reduce((acc, section) => [...acc, ...(!section.disabled ? section.routes : [])], []));
